/* eslint-disable @typescript-eslint/no-empty-function */
import { Col, Container, Row } from 'react-bootstrap';
import Button from '../../../../components/Button';
import { ButtonContainer } from '../../../../components/Form';
import Loader from '../../../../components/Loader';
import OpacityAnimation from '../../../../components/OpacityAnimation';
import PageHeader from '../../../../components/PageHeader';
import GeneralDataCard from './components/GeneralDataCard';
import PermissionsCard from './components/PermissionsCard';
import PermissionsOsPageModal from './components/PermissionsOfPageModal';
import useClientUserForm from './useClientUserForm';

interface IClientUserForm {
  edit?: boolean
}

export default function ClientUserForm({ edit = false }: IClientUserForm) {
  const {
    name,
    cpf,
    email,
    type,
    typeOptions,
    permissionsOptions,
    selectedPermissions,
    pageBeingSettedPermissions,
    permissionsOfPageModalShow,
    selectedActions,
    getErrorMessageByFieldName,
    handleNameChange,
    handleCpfChange,
    handleEmailChange,
    handleTypeChange,
    handleActionSelect,
    handleOpenPageBeingSettedPermissionsModal,
    handlePermissionsChange,
    setPermissionsOfPageModalShow,
    createUser,
    editUser,
    isLoading,
    isFormValid,
  } = useClientUserForm();

  return (
    <>
      <Loader isLoading={isLoading} />
      {edit && (
        <PageHeader
          title={`Editar Usuário ${name}`}
          link="/clientUsers"
        />
      )}
      <Container>
        <Row xs={1} md={1} lg={1}>
          <Col>
            <OpacityAnimation>
              <GeneralDataCard
                getErrorMessageByFieldName={getErrorMessageByFieldName}
                name={name}
                cpf={cpf}
                email={email}
                type={type}
                typeOptions={typeOptions}
                isTypeSelectDisabled={type?.value === 3 && edit}
                handleNameChange={handleNameChange}
                handleCpfChange={handleCpfChange}
                handleEmailChange={handleEmailChange}
                handleTypeChange={handleTypeChange}
                edit={edit}
              />
            </OpacityAnimation>
          </Col>
          {type.value !== 3 && (
            <Col>
              <OpacityAnimation>
                <PermissionsCard
                  permissionsOptions={permissionsOptions}
                  selectedPermissions={selectedPermissions}
                  handleOpenPageBeingSettedPermissionsModal={handleOpenPageBeingSettedPermissionsModal}
                />
              </OpacityAnimation>
            </Col>
          )}
        </Row>

        <ButtonContainer>
          {!edit && (
            <Button disabled={!isFormValid} onClick={createUser}>
              {`Adicionar usuário ${name ?? ''}`}
            </Button>
          )}

          {edit && (
            <Button disabled={!isFormValid} onClick={editUser}>
              {`Editar usuário ${name ?? ''}`}
            </Button>
          )}
        </ButtonContainer>

      </Container>

      <PermissionsOsPageModal
        pageBeingSettedPermissions={pageBeingSettedPermissions}
        permissionsOfPageModalShow={permissionsOfPageModalShow}
        selectedActions={selectedActions}
        handleActionSelect={handleActionSelect}
        handlePermissionsChange={handlePermissionsChange}
        setPermissionsOfPageModalShow={setPermissionsOfPageModalShow}
      />
    </>
  );

}
